// src/components/AdminPage.jsx
import { useState } from "react";

function ExpandRow({ d }) {
  const [open, setOpen] = useState(false);
  let episodes = [];
  try { episodes = JSON.parse(d.episodes || "[]"); } catch {}

  return (
    <>
      <tr
        style={{ borderBottom: open ? "none" : "1px solid #f5ede5", cursor: "pointer" }}
        onClick={() => setOpen(!open)}
      >
        <td style={tdStyle}>{new Date(d.created_at).toLocaleDateString("ko-KR")}</td>
        <td style={tdStyle}>{d.user_name}</td>
        <td style={tdStyle}>{d.animal_type}</td>
        <td style={tdStyle}>{d.animal_name}</td>
        <td style={tdStyle}>
          <span style={{
            padding: "3px 8px", borderRadius: 8, fontSize: 12,
            background: d.alive_status === "alive" ? "#e8f5e8" : "#f0eaff",
            color: d.alive_status === "alive" ? "#4a8a4a" : "#7a6aaa",
          }}>
            {d.alive_status === "alive" ? "함께" : "하늘"}
          </span>
        </td>
        <td style={tdStyle}>{d.personalities}</td>
        <td style={{ ...tdStyle, maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {d.letter_text?.slice(0, 50)}...
        </td>
        <td style={{ ...tdStyle, fontSize: 18, textAlign: "center" }}>
          {open ? "▲" : "▼"}
        </td>
      </tr>
      {open && (
        <tr style={{ borderBottom: "1px solid #f5ede5" }}>
          <td colSpan={8} style={{ padding: 0 }}>
            <div style={{
              background: "#fdf9f5", padding: "24px 28px",
              borderTop: "1px dashed #e4d0bc",
            }}>
              {/* 에피소드 */}
              <div style={{ marginBottom: 20 }}>
                <div style={{
                  fontFamily: "'Jua', sans-serif", fontSize: 16,
                  color: "#c4845a", marginBottom: 12,
                }}>
                  에피소드
                </div>
                {episodes.length === 0 ? (
                  <div style={{ fontSize: 16, fontWeight: 400, color: "#c8b0a0" }}>에피소드 없음</div>
                ) : (
                  episodes.map((ep, i) => (
                    <div key={i} style={{
                      background: "white", borderRadius: 12, padding: "14px 18px",
                      marginBottom: 8, border: "1px solid #ead6c0",
                    }}>
                      <div style={{ fontSize: 13, color: "#c4845a", fontFamily: "'Jua', sans-serif", marginBottom: 6 }}>
                        에피소드 {i + 1}: {ep.title}
                      </div>
                      <div style={{ fontSize: 16, fontWeight: 400, color: "#5c3d2e", lineHeight: 1.8, whiteSpace: "pre-line" }}>
                        {ep.content}
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* 편지 전문 */}
              <div>
                <div style={{
                  fontFamily: "'Jua', sans-serif", fontSize: 16,
                  color: "#c4845a", marginBottom: 12,
                }}>
                  편지 전문
                </div>
                <div style={{
                  background: "white", borderRadius: 12, padding: "20px 24px",
                  border: "1px solid #ead6c0",
                  fontSize: 16, fontWeight: 400, color: "#5c3d2e", lineHeight: 2.2,
                  whiteSpace: "pre-line", fontFamily: "'Gowun Batang', serif",
                }}>
                  {d.letter_text || "(없음)"}
                </div>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

function exportToExcel(data) {
  const BOM = "\uFEFF";
  const headers = ["날짜", "사용자", "성별", "동물종류", "동물이름", "상태", "기간", "성격", "에피소드", "편지전문"];

  const rows = data.map((d) => {
    let episodes = [];
    try { episodes = JSON.parse(d.episodes || "[]"); } catch {}
    const episodeText = episodes.map((ep, i) => `[${i + 1}] ${ep.title}: ${ep.content}`).join(" | ");

    return [
      new Date(d.created_at).toLocaleDateString("ko-KR"),
      d.user_name || "",
      d.gender || "",
      d.animal_type || "",
      d.animal_name || "",
      d.alive_status === "alive" ? "함께" : "하늘",
      d.period || "",
      d.personalities || "",
      episodeText,
      (d.letter_text || "").replace(/\n/g, " "),
    ];
  });

  const escape = (val) => {
    const str = String(val);
    if (str.includes(",") || str.includes('"') || str.includes("\n")) {
      return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
  };

  const csv = BOM + [headers, ...rows].map((row) => row.map(escape).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `펫말_데이터_${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}

export default function AdminPage() {
  const [password, setPassword] = useState("");
  const [authed, setAuthed] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState(null);
  const [filter, setFilter] = useState("all");

  const login = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/admin", {
        headers: { "x-admin-key": password },
      });
      if (!res.ok) { alert("비밀번호가 틀렸어요."); setLoading(false); return; }
      const json = await res.json();
      setData(json.data || []);
      setStats(json.stats || null);
      setAuthed(true);
    } catch {
      alert("데이터를 불러오지 못했어요.");
    }
    setLoading(false);
  };

  const filtered = filter === "all" ? data : data.filter((d) => d.alive_status === filter);

  if (!authed) {
    return (
      <div style={{ minHeight: "100vh", background: "#fdf6ee", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{
          background: "white", borderRadius: 24, padding: "48px 36px",
          boxShadow: "0 4px 24px rgba(92,61,46,0.07)", textAlign: "center", maxWidth: 360, width: "100%",
        }}>
          <div style={{ fontSize: 36, marginBottom: 16 }}>🔒</div>
          <div style={{ fontFamily: "'Jua', sans-serif", fontSize: 22, fontWeight: 700, color: "#5c3d2e", marginBottom: 20 }}>
            펫말 Admin
          </div>
          <input
            type="password"
            placeholder="관리자 비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && login()}
            style={{
              width: "100%", padding: "14px 16px", border: "1.5px solid #ead6c0",
              borderRadius: 14, fontSize: 16, fontWeight: 400, fontFamily: "'Gowun Batang', serif",
              color: "#5c3d2e", background: "#fdf9f5", outline: "none", marginBottom: 16,
            }}
          />
          <button
            onClick={login}
            disabled={loading}
            style={{
              width: "100%", padding: 16, borderRadius: 16,
              background: "linear-gradient(135deg, #c4845a, #d4a070)",
              color: "white", fontSize: 16, fontWeight: 700, fontFamily: "'Jua', sans-serif",
              border: "none", cursor: "pointer",
            }}
          >
            {loading ? "로딩 중..." : "로그인"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#fdf6ee", padding: "24px 20px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        {/* 헤더 */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <div style={{ fontFamily: "'Jua', sans-serif", fontSize: 28, fontWeight: 700, color: "#5c3d2e" }}>
            🐾 펫말 Admin
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={() => exportToExcel(filtered)}
              style={{
                padding: "8px 16px", borderRadius: 10,
                background: "#5c3d2e", color: "white",
                cursor: "pointer", fontSize: 16, fontWeight: 700, border: "none",
                fontFamily: "'Jua', sans-serif",
              }}
            >
              CSV 다운로드
            </button>
            <button
              onClick={() => { setAuthed(false); setPassword(""); }}
              style={{
                padding: "8px 16px", borderRadius: 10, border: "1.5px solid #ead6c0",
                background: "white", color: "#b09070", cursor: "pointer", fontSize: 16, fontWeight: 400,
              }}
            >
              로그아웃
            </button>
          </div>
        </div>

        {/* 통계 카드 */}
        {stats && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 16, marginBottom: 28 }}>
            {[
              { label: "총 편지", value: stats.total, emoji: "📬" },
              { label: "함께하는 친구", value: stats.alive, emoji: "🏠" },
              { label: "하늘 너머", value: stats.rainbow, emoji: "✉️" },
              { label: "오늘", value: stats.today, emoji: "📅" },
            ].map((s) => (
              <div key={s.label} style={{
                background: "white", borderRadius: 16, padding: "20px 16px",
                boxShadow: "0 2px 12px rgba(92,61,46,0.06)", textAlign: "center",
              }}>
                <div style={{ fontSize: 28, marginBottom: 6 }}>{s.emoji}</div>
                <div style={{ fontFamily: "'Jua', sans-serif", fontSize: 28, color: "#5c3d2e" }}>{s.value}</div>
                <div style={{ fontSize: 13, color: "#b09070" }}>{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* 필터 */}
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          {[
            { id: "all", label: "전체" },
            { id: "alive", label: "함께하는 친구" },
            { id: "rainbow", label: "하늘 너머" },
          ].map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              style={{
                padding: "8px 16px", borderRadius: 10,
                border: `1.5px solid ${filter === f.id ? "#c4845a" : "#ead6c0"}`,
                background: filter === f.id ? "#fff0e8" : "white",
                color: filter === f.id ? "#c4845a" : "#b09070",
                cursor: "pointer", fontSize: 16, fontWeight: 400,
              }}
            >
              {f.label} ({f.id === "all" ? data.length : data.filter((d) => d.alive_status === f.id).length})
            </button>
          ))}
        </div>

        {/* 데이터 테이블 */}
        <div style={{ overflowX: "auto" }}>
          <table style={{
            width: "100%", borderCollapse: "collapse", background: "white",
            borderRadius: 16, overflow: "hidden",
            boxShadow: "0 2px 12px rgba(92,61,46,0.06)",
          }}>
            <thead>
              <tr style={{ background: "#fdf9f5" }}>
                {["날짜", "사용자", "동물", "이름", "상태", "성격", "편지 미리보기", ""].map((h) => (
                  <th key={h} style={{
                    padding: "14px 12px", fontSize: 13, color: "#b09070",
                    fontWeight: "normal", textAlign: "left", borderBottom: "1px solid #f0e4d8",
                  }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ padding: 40, textAlign: "center", color: "#c8b0a0", fontSize: 16, fontWeight: 400 }}>
                    아직 데이터가 없어요.
                  </td>
                </tr>
              ) : (
                filtered.map((d, i) => (
                  <ExpandRow key={i} d={d} />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const tdStyle = {
  padding: "12px 12px",
  fontSize: 16,
  fontWeight: 400,
  color: "#5c3d2e",
};
